<template>
  <v-dialog
    v-model="dialog"
    :width="dialogWidth"
    transition="fade-transition"
    :scrollable="true"
  >
    <v-card>
      <v-card-title class="headline">{{ $t("coins.title") }}</v-card-title>
      <v-card-text>
        <v-container class="pt-0 pb-0">
          <v-row>
            <v-col cols="auto">
              <coin-balance />
            </v-col>
            <v-col>
              <v-btn
                fab
                x-small
                @click="refreshBalance"
                :aria-label="$t('common.refresh')"
                :disabled="$store.state.isLoading"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <coin-products class="pt-0" />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="secondary" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{ $t("common.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CoinProducts from "@/widgets/CoinProducts";
import CoinBalance from "@/widgets/CoinBalance";
import { ACTION_LOAD_COIN_ACCOUNT } from "@/plugins/store";

export default {
  name: "CoinsDialog",
  mixins: [],
  components: { CoinProducts, CoinBalance },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    dialogWidth: function () {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "700";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    refreshBalance() {
      this.$store.dispatch(ACTION_LOAD_COIN_ACCOUNT)
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
</style>